<template>
    <div class="modal-title">Дополнительный e-mail</div>
    <form class="modal-form">
        <input-text
            label       = "E-mail адрес"
            required    = "*"
            :errorText  = "updateError"
            placeholder = "E-mail адрес"
            maskVal     = "email"
            name        = "email"
            disabled    = "inputDisabled"
            :defValue   = "dataUser.extra_email"
            @complete   ="complete"
        />
        <div class="modal-button flex">
            <orange-button
                text            = "Сохранить"
                @click.prevent  = "addEmailUpdate"
                ref             = "submitButton"
            />
            <button class="button reset" @click.prevent="$emit('showModal')">Отмена</button>
        </div>
    </form>
</template>

<script>
import axios from "axios"

export default {
    name: 'modal-additional-email',
    emits: ['showModal'],
    data() {
        return {
            email: '',
            updateError: false,
            apiUrl: this.$store.state.apiUrl,
            token: this.$store.state.token,
        }
    },
    computed: {
        dataUser() {
            return this.$store.state.dataUser
        }
    },
    methods: {
        complete(e) {
            this.email = e.target.value
        },
        async addEmailUpdate() {
            try {
                if (!this.email)
                    this.updateError = 'Укажите E-mail'
                else {
                    const response = await axios.patch(
                        this.apiUrl + '/api/user',
                        {
                            user: {extra_email: this.email}
                        },
                        {
                            headers: {
                                'Content-Type': 'application/json',
                                'Authorization': 'Bearer ' + this.token
                            }
                        }
                    )
                    this.$emit('showModal')
                    this.$store.commit('getUserInfo')
                }
            } catch (e) {
                console.log(e.response ? { status: e.response.status, data: e.response.data } : e.message)
            }
        }
    }
}
</script>